
export class Form {
    constructor(selector) {
        let _this = this;

        _this.$container = $(selector);
        if (!_this.$container.length) return;

        _this.FormId = _this.$container.data('form-id');
        if (!_this.FormId) throw new Error('js-form element requires "data-form-id" attr set');

        _this.$btnSubmit = _this.$container.find('.js-form-submit');
        _this.$inputs = _this.$container.find('.js-form-input');
        _this.isToValidate = _this.$container.is('._to-validate');
        _this.isLoading = false;

        _this._container = this;

        _this.$container.data('_form', _this._container);

        _this.init();
    }

    init() {
        let _this = this;
        let $form = _this.$container;
        let $btnSubmit = _this.$btnSubmit;

        $btnSubmit.on('click', (e) => {
            e.preventDefault();
            if (_this.isLoading) return false;
            _this.submitForm();
        });
        $form.on('submit', (e) => {
            e.preventDefault();
            if (_this.isLoading) return false;
            _this.submitForm();
        })
    }

    async submitForm(queryMethod, loggingOut = false) {
        let _this = this;
        let $form = _this.$container;

        $form.removeClass('was-validated');

        if (!loggingOut) {
            let isValid = $form[0].checkValidity();
            $form.addClass('was-validated');

            if (!isValid) return false;

            const formData = Form.getValues(_this.FormId);

            try {
                _this.setLoading(true);
                const tokenData = await queryMethod(formData);
                const token = tokenData.data.login.token;
                _this.onSubmitSuccess({token, logged: true});
            } catch(e) {
                console.error(e);
                _this.onSubmitFail();
            }
        } else {

            try {
                _this.setLoading(true);
                await queryMethod();
                _this.onSubmitSuccess({logged: false});
            } catch(e) {
                console.error(e);
                _this.onSubmitFail();
            }

        }
    }
    onSubmitSuccess(data) {
        let _this = this;
        _this.setLoading(false);

        _this.$container.trigger('submitted', data);
    }
    onSubmitFail() {
        let _this = this;
        _this.setLoading(false);

        _this.$container.addClass('_submit-failed');
        _this.$container.trigger('failed');
    }

    reset() {
        let _this = this;
        let $form = _this.$container;

        $form.removeClass('was-validated _submit-failed');
        $form[0].reset();
    }
    setLoading(isLoading = false) {
        let _this = this;

        _this.isLoading = isLoading;
        _this.$container.toggleClass('_loading', isLoading);
    }
    static getValues(FormId) {
        const $form = $('.js-form[data-form-id="'+FormId+'"]');
        const _form = $form.data('_form');
        const $inputs = _form.$inputs;
        const formData = {};
        $inputs.each((i, { name, value }) => {
            formData[name] = value;
        });

        return formData;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/src/Form.js